<template>
  <main
    class="container"
    :class="`container--${backgroundColor}`">

    <transition
      v-if="siteContent"
      name="content">
      <contents
        v-if="siteContent"
        :content="siteContent" />
    </transition>

    <transition
      v-if="siteContent"
      name="page">
      <router-view
        :default="siteContent.home"
        @toggleActive="toggleActive"
        @switchToPage="toggleActive" />
    </transition>

    <Footer
      v-if="siteContent"
      :pages="navPages"
      :index="pageIndex" />
  </main>
</template>

<script>
import Contents from '@/components/Contents'
import Footer from '@/components/Footer'

export default {
  name: 'Container',
  components: {
    Contents,
    Footer
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      siteContent: null,
      pageIndex: 0,
      navPages: null
    }
  },
  watch: {
    '$route': function() {
      this.pageIndex = this.getIndex()
    }
  },
  async created() {
    this.siteContent = await this.getSite()

    this.pageIndex = this.getIndex()

    const navPages = this.siteContent.pages

    if (navPages && this.siteContent.pages.findIndex(page => page.name === this.siteContent.home.name) === -1) {
      navPages.unshift(this.siteContent.home)
    }

    this.navPages = navPages

    setTimeout(() => {
      this.$root.$emit('toggleCover', true)
    }, 500)
  },
  methods: {
    getSite() {
      const url = `${process.env.VUE_APP_API_ADDRESS}/collection/base`

      const siteUrl = this.$router.options.routes[0].siteUrl

      return new Promise(async resolve => {
        fetch(url, {
          method: 'POST',
          headers: this.$headers,
          body: JSON.stringify({ collection: siteUrl })
        })
          .then(response => response.json())
          .then(result => resolve(result))
      })
    },
    getIndex() {
      if (this.siteContent.pages && this.siteContent.pages.length) {
        let index = this.siteContent.pages.findIndex(page => {

          let link = page.link.includes('/') ? page.link : `/${page.link}`
            if (this.$route.path === link) return true
          })

        return index > -1 ? index : 0
      }
      return 0
    },
    toggleActive(state) {
      if (!this.$mobile) return false

      this.active = state
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
</style>
